var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-container"},[_c('p',[_vm._v(_vm._s(_vm.loadingMsg))]),_c('div',{staticClass:"global-spinner"})])}
var staticRenderFns = []

export { render, staticRenderFns }